module.exports = __webpack_public_path__ + "img/bind.a620b7ff.svg";